import { Component, OnDestroy, OnInit } from '@angular/core';
import { WaitListDetailsController } from '../wait-list-details.controller';

@Component({
	selector: 'wait-list-details-desktop-component',
	templateUrl: 'wait-list-details.desktop.component.html',
	styleUrls: ['./wait-list-details.desktop.component.scss'],
})
export class WaitListDetailsDesktopComponent implements OnInit, OnDestroy {
	constructor(public readonly controller: WaitListDetailsController) {}

	public async ngOnInit(): Promise<void> {
		this.controller.onInit();
	}
	public ngOnDestroy(): void {
		this.controller.onDestroy();
	}
}
